const mirukiku_product = {
    question_free_text: '先生の指示を聞いて自分の考えを入力しよう',
};

export default mirukiku_product;
